import React from 'react';
import { connect } from 'react-redux';

import { goTo } from '../../tools';
import PasoDosEliminarCuenta from '../../miPerfil/pasoDosEliminarCuenta.cmpt';

const mapState = (state) => {
    if (state.movil.identidadValida) {
        goTo("movil/detalle");
        //window.location.href = "/#!/movil/detalle";
    }
    
    return {
        loading: state.global.loading
    };
}

class IdentidadMovil extends React.Component {
    render() {
        return <div className="card">
            <PasoDosEliminarCuenta movil={true}/>
        </div>
    }
}

export default connect(mapState)(IdentidadMovil);


// WEBPACK FOOTER //
// ./src/movil/polizas/identidadMovil.cmpt.js